export default __webpack_public_path__ + "static/media/akssai-banner.5b8f3db4.png";